import React from 'react';
import { HeaderText } from '@/components';
import { HeaderSize } from '@/components/ui/HeaderText';
import { formatPossessiveProperNoun, interpolate } from '@/utils/translations';
import { formatDateForDisplay } from '@/utils/dates/dateFormatters';
import { useLocale } from 'next-intl';
import { TypePlayKitPageTranslations } from '@/utils/translations/types/TypePlayKitPageTranslations';
import { TypeChildRecord } from '@/lib/api/accountManager/types';
import { DisplayDateFormat } from '@/utils/dates';

export interface SubscriptionPageHeadingProps {
  t: TypePlayKitPageTranslations;
  selectedChild?: TypeChildRecord;
}

function SubscriptionPageHeading({
  t,
  selectedChild,
}: SubscriptionPageHeadingProps) {
  const locale = useLocale();

  return (
    <div className="md:text-center text-left mb-10 mt-6">
      {selectedChild ? (
        <>
          <HeaderText
            classes="pb-2.5"
            size={HeaderSize.H1}
            text={interpolate(t.childsPlayKits, {
              childName: formatPossessiveProperNoun(selectedChild.name, locale),
            })}
          />
          <p>
            <span className="font-bold">{interpolate(t.birthdate)}</span>
            {formatDateForDisplay(
              selectedChild.birthday,
              locale,
              DisplayDateFormat.NumericMonthDayYear,
            ) || ''}
          </p>
        </>
      ) : (
        <HeaderText
          classes="pb-2.5"
          size={HeaderSize.H1}
          text={t.noActiveSubscriptions}
        />
      )}
    </div>
  );
}

export default SubscriptionPageHeading;
